import { CONTACT, NAV } from "@/lib/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink-950 border-t border-ivory/[0.06] pt-16 pb-8"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 md:gap-12">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="font-mono-caps text-[10px] text-copper">PM</span>
              <span className="h-3 w-px bg-ivory/20" />
              <span className="font-serif italic text-2xl text-ivory">Parin Majithia</span>
            </div>
            <p className="font-serif italic text-2xl md:text-3xl text-ivory leading-tight max-w-md">
              Designing Spaces. Developing Landmarks.{" "}
              <span className="text-copper">Building a Legacy.</span>
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="font-mono-caps text-[9px] text-copper mb-4">Explore</div>
            <ul className="space-y-2">
              {NAV.map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.id}`}
                    className="text-ivory/70 hover:text-copper text-sm transition-colors"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-6 md:col-span-4">
            <div className="font-mono-caps text-[9px] text-copper mb-4">Reach</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="text-ivory/80 hover:text-copper transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={`tel:${CONTACT.phone_e164}`} className="text-ivory/80 hover:text-copper transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="text-ivory/80 hover:text-copper transition-colors">
                  {CONTACT.instagram_handle}
                </a>
              </li>
              <li>
                <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" className="text-ivory/80 hover:text-copper transition-colors">
                  linkedin.com/in/parinmajithia
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-ivory/[0.06] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono-caps text-[9px] text-ivory/40">
            © {year} Parin Majithia · Mumbai, India. All rights reserved.
          </p>
          <p className="font-mono-caps text-[9px] text-ivory/40">
            Site crafted with care · parinmajithia.com
          </p>
        </div>
      </div>
    </footer>
  );
}
